import { render, staticRenderFns } from "./default-swipe.mpx?vue&type=template&id=d35f71f0&isComponent&outputPath=components%2Fdefault-swipeb24857f8%2Findex"
import script from "./default-swipe.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdefault-swipeb24857f8%2Findex"
export * from "./default-swipe.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdefault-swipeb24857f8%2Findex"
import style0 from "./default-swipe.mpx?vue&type=style&index=0&id=d35f71f0&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_b24857f8%22%7D&isComponent&outputPath=components%2Fdefault-swipeb24857f8%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports